import React, { PropTypes } from 'react';
import Snackbar from 'material-ui/Snackbar';
import { LocalizedMessage } from '../../utilites/translate';
import { FormattedMessage } from 'react-intl';

class Messages extends React.Component {
  static propTypes = {
    messages: PropTypes.array.isRequired
  };

  getMessage(message) {
    if (message instanceof LocalizedMessage) {
      return ( <FormattedMessage key={message.msg} id={message.msg} values={message.values}/> );
    } else {
      return message;
    }
  }

  renderMessage(item) {
    let messages = item.message instanceof Array ? item.message : [item.message];

    return (
      <Snackbar
        key={item.id}
        action='Dismiss'
        open={true}
        message={<div>{ messages.map(message => this.getMessage(message)) }</div>}
        autoHideDuration={5000}
        onActionTouchTap={() => this.props.hideMessage(item.id)}
        type='cancel'
      />
    );
  }

  render() {
    return (
      <div>
        {this.props.messages.map((item) => this.renderMessage(item))}
      </div>
    );
  }
}

export default Messages;



// WEBPACK FOOTER //
// ./src/components/Messages/component.jsx